import formatdate from "./format"
import store from "@/store"
import {
    IpRegionMap,
    ProductTypeMap,
    LineStatusMap
} from "./constants"
import {
    h
} from "vue"

const appList = [{
    width: "30",
    align: 'left',
    selection: true,
}, {
    prop: "appName",
    label: "应用名称",
    width: "200",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "appsize",
    label: "应用大小",
    width: "200",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "apptext",
    label: "备注",
    width: "200",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,

    formatter: (row, column, cellValue, index) => {
        let a = {}
        if (row.isShowBtn) {
            a = {
                class: 'icon-edit-name iconfont icon-bianji',
                style: {
                    'margin-left': '6px',
                    'cursor': 'pointer'
                },
                on: {
                    'click': () => {
                        editegroup(row)
                    }
                }
            }
        }
        return h('div', [
            cellValue,
            h('span',
                a,
            ),
        ])
    }
}]
//分组列表
const grouplist = [{
        prop: "Name",
        label: "分组名称",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "Id",
        label: "分组ID",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
]
//子账号列表
const subaccountlist = [{
    prop: "UserId",
    label: "用户ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: 'Username',
    label: '用户名',
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "NickName",
    label: "昵称",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}]
//订单列表
const orderList = [{
    prop: "OrderId",
    label: "订单ID",
    width: "145",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false
}, {
    prop: "OrderType",
    label: "订单类型",
    width: "130",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        if (cellValue == "NEW") {
            return "新增"
        } else if (cellValue == "RENEW") {
            return "续费"
        } else {
            return cellValue
        }
    }
}, {
    prop: "ResourceType",
    label: "资源类型",
    width: "130",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        if (cellValue == "PATH") {
            return '直播快'
        } else {
            return cellValue
        }
    }
}, {
    prop: "Total",
    label: "购买金额",
    width: "80",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false
}, {
    prop: "CreateTime",
    label: "创建时间",
    width: "135",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "FinishTime",
    label: "完成时间",
    width: "135",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}]
//续费表格
const renewList = [{
    prop: "product_type",
    label: "产品类型",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        if (cellValue == "Path") {
            return '直播快'
        } else {
            return cellValue
        }
    }
}, {
    prop: "region",
    label: "地域",
    width: "80",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return IpRegionMap[cellValue] || cellValue
    }
}, {
    prop: "config_type",
    label: "配置类型",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        if (cellValue == "universal") {
            return '通用版'
        } else if (cellValue == "live") {
            return '直播版'
        } else if (cellValue == "matrix") {
            return '矩阵版'
        } else if (cellValue == "phone-advanced") {
            return '精品版'
        } else if (cellValue == "phone-shared") {
            return '共享版'
        } else if (cellValue == "phone-exclusive") {
            return '独享版'
        } else if (cellValue == "phone-noip") {
            return '无网版'
        } else if (cellValue == "phone-social") {
            return '天晴定制版'
        } else if (cellValue == "phone-matrix") {
            return '矩阵1:4版'
        } else if (cellValue == "phone-ip") {
            return '精品IP版'
        }else if (cellValue == "phone-matrix8") {
            return '矩阵1:8版'
        }else if (cellValue == "phone-matrix16") {
            return '矩阵1:16版'
        }else {
            return cellValue
        }
    }
}, {
    prop: "name",
    label: "资源名称",
    width: "120",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "group",
    label: "业务组",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false
}, {
    prop: "status",
    label: "状态",
    width: "80",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        if (cellValue == "RUNNING") {
            return '运行中'
        } else if (cellValue == "CREATING") {
            return '创建中'
        } else {
            return cellValue
        }
    }
}]
// 直播加速续费列表
const lineRenewList = [{
        prop: "product_type",
        label: "产品类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            if (cellValue == "Path") {
                return '直播快'
            } else {
                return cellValue
            }
        }
    },
    {
        prop: "name",
        label: "名称",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "ipRegion",
        label: "地域",
        width: "80",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            console.log(row)
            return IpRegionMap[cellValue] || cellValue
        }
    }, {
        prop: "productId",
        label: "配置类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return ProductTypeMap[cellValue] || cellValue
        }
    },
    {
        prop: "groupName",
        label: "业务组",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false
    }, {
        prop: "status",
        label: "状态",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return LineStatusMap[cellValue] || cellValue
        }
    }
]
//上传文件列表
const filecloumns = [{
    prop: "filename",
    label: "文件名",
    width: "150",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filesize",
    label: "文件大小",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filetype",
    label: "文件类型",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "fileprogress",
    label: "进度",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "filestate",
    label: "状态",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}]
//文件管理列表
const filestoragelist = [{
        prop: "FileName",
        label: "文件名",
        width: "120",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false
    }, {
        prop: "FileType",
        label: "文件类型",
        width: "120",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return "本地文件"
        }
    },
    {
        prop: "Size",
        label: "文件大小(GB)",
        width: "120",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false
    }, {
        prop: "UploadTime",
        label: "上传时间",
        width: "120",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return formatdate(cellValue, 'YYYY-MM-DD')
        }
    }, {
        prop: "Remark",
        label: "文件备注",
        width: "120",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            if (cellValue) {
                return cellValue;
            } else {
                return "-";
            }
        },
    }
]
//渠道汇总
const channelmainaccount = [{
        prop: "CompanyName",
        label: "公司名称",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return h('div', [
                cellValue || "-",
                h('span', {
                    class: "icon-edit-name iconfont icon-bianji",
                    style: {
                        "margin-left": "6px",
                        "cursor": "pointer"
                    },
                    on: {
                        'click': () => {
                            editChannelCompany(row)
                        }
                    }
                }, )
            ])
        }
    }, {
        prop: "UserId",
        label: "专网ID",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "PhoneNumber",
        label: "专网手机号",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "PathCurrentCount",
        label: "直播快当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "PathDiscount",
        label: "直播快折扣",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "1.0"
        }
    }, {
        prop: "PhoneCurrentCount",
        label: "当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "PhoneDiscount",
        label: "折扣",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "1.0"
        }
    }, {
        prop: "RouterCount",
        label: "路由器当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },{
        prop: "Saler",
        label: "销售",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return h('div', [
                cellValue,
                h('span', {
                    class: "icon-edit-name iconfont icon-bianji",
                    style: {
                        "margin-left": "6px",
                        "cursor": "pointer"
                    },
                    on: {
                        'click': () => {
                            showSetInviter(row)
                        }
                    }
                }, )
            ])
        }
    }, {
        prop: "ChannelOuterId",
        label: "关联ID",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return h('div', [
                cellValue || "-",
                h('span', {
                    class: "icon-edit-name iconfont icon-bianji",
                    style: {
                        "margin-left": "6px",
                        "cursor": "pointer"
                    },
                    on: {
                        'click': () => {
                            editChannelOuterId(row)
                        }
                    }
                }, )
            ])
        }
    }, {
        prop: "Inviter",
        label: "邀请人",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            if (cellValue) {
                return cellValue;
            } else {
                return "-";
            }
        },
    }
]
//渠道客户数据
const channelsubaccount = [{
        prop: "CompanyName",
        label: "公司名称",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return h('div', [
                cellValue || "-",
                h('span', {
                    class: "icon-edit-name iconfont icon-bianji",
                    style: {
                        "margin-left": "6px",
                        "cursor": "pointer"
                    },
                    on: {
                        'click': () => {
                            editChannelCompany(row)
                        }
                    }
                }, )
            ])
        }
    },
    {
        prop: "PhoneNumber",
        label: "专网手机号",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "CreateTime",
        label: "注册日期",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return formatdate(cellValue, 'YYYY-MM-DD')
        }
    },
    {
        prop: "UserId",
        label: "专网ID",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "AuditStatus",
        label: "审核状态",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "PathDiscount",
        label: "直播快折扣",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "1.0"
        }
    }, {
        prop: "PathCurrentCount",
        label: "直播快当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "PhoneDiscount",
        label: "折扣",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "1.0"
        }
    }, {
        prop: "PhoneCurrentCount",
        label: "当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    }, {
        prop: "RouterCount",
        label: "路由器当前资源数",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },{
        prop: "ChannelOuterId",
        label: "关联ID",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return h('div', [
                cellValue || "-",
                h('span', {
                    class: "icon-edit-name iconfont icon-bianji",
                    style: {
                        "margin-left": "6px",
                        "cursor": "pointer"
                    },
                    on: {
                        'click': () => {
                            editChannelOuterId(row)
                        }
                    }
                }, )
            ])
        }
    }, {
        prop: "Inviter",
        label: "邀请人",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            if (cellValue) {
                return cellValue;
            } else {
                return "-";
            }
        },
    }
]
//渠道数据
const channelResrouce = [{
    prop: "PhoneNumber",
    label: "专网手机号",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "UserId",
    label: "专网ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "ResourceType",
    label: "资源类型",
    width: "80",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "ResourceId",
    label: "资源ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false
}, {
    prop: "ProductId",
    label: "产品",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return ProductTypeMap[cellValue] || cellValue
    }
}, {
    prop: "RegionId",
    label: "地区",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return IpRegionMap[cellValue] || cellValue
    }
}, {
    prop: "Ip",
    label: "IP",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || "-"
    }
}, {
    prop: "Discount",
    label: "折扣",
    width: "50",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || '1.0'
    }
}, {
    prop: "CreateTime",
    label: "资源创建时间",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return formatdate(cellValue, 'YYYY-MM-DD')
    }
}, {
    prop: "ExpireTime",
    label: "资源到期时间",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return formatdate(cellValue, 'YYYY-MM-DD')
    }
}, {
    prop: "Status",
    label: "资源状态",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return LineStatusMap[cellValue] || cellValue
    }
}, {
    prop: "ChannelOuterId",
    label: "关联ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || "-"
    }
}]

//渠道所有账号数据
const channelMainResrouce = [{
    prop: "PhoneNumber",
    label: "专网手机号",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "UserId",
    label: "专网ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "ResourceType",
    label: "资源类型",
    width: "80",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "ResourceId",
    label: "资源ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false
}, {
    prop: "ProductId",
    label: "产品",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return ProductTypeMap[cellValue] || cellValue
    }
}, {
    prop: "RegionId",
    label: "地区",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return IpRegionMap[cellValue] || cellValue
    }
}, {
    prop: "Ip",
    label: "IP",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || "-"
    }
}, {
    prop: "Discount",
    label: "折扣",
    width: "50",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || '1.0'
    }
}, {
    prop: "CreateTime",
    label: "资源创建时间",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return formatdate(cellValue, 'YYYY-MM-DD')
    }
}, {
    prop: "ExpireTime",
    label: "资源到期时间",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return formatdate(cellValue, 'YYYY-MM-DD')
    }
}, {
    prop: "Status",
    label: "资源状态",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return LineStatusMap[cellValue] || cellValue
    }
}, {
    prop: "Saler",
    label: "销售",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "SalerId",
    label: "销售ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
}, {
    prop: "ChannelOuterId",
    label: "关联ID",
    width: "100",
    align: 'left',
    headerAlign: 'left',
    selection: false,
    index: false,
    expand: false,
    formatter: (row, column, cellValue, index) => {
        return cellValue || "-"
    }
}]
//收入明细
const moneydetaillist = [{
        prop: "OrderId",
        label: "订单号",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "CreateTime",
        label: "交易时间",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return formatdate(cellValue, 'YYYY-MM-DD')
        }
    },
    {
        prop: "Type",
        label: "交易类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Total",
        label: "交易金额",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return "¥" + cellValue / 100.00;
        }
    }
]

const invoicelist = [{
        prop: "Id",
        label: "序号",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "InvoiceInfo.Type",
        label: "发票类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "InvoiceInfo.IssueType",
        label: "开具类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "InvoiceInfo.Title",
        label: "发票抬头",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "Amount",
        label: "金额（元）",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return (cellValue / 100.00).toFixed(2);
        }

    },
    {
        prop: "Remark",
        label: "发票备注（选填）",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Status",
        label: "状态",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    }
]

const invoicedetaillist = [{
        prop: "Type",
        label: "发票类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "IssueType",
        label: "开具类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Title",
        label: "发票抬头",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Medium",
        label: "发票介质",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Email",
        label: "邮箱",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "-"
        }

    },
]
const invoicedetaillist2 = [{
        width: "30",
        align: 'left',
        selection: true,
    }, {
        prop: "Type",
        label: "发票类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "IssueType",
        label: "开具类型",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Title",
        label: "发票抬头",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Medium",
        label: "发票介质",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Email",
        label: "邮箱",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
        formatter: (row, column, cellValue, index) => {
            return cellValue || "-"
        }

    },
]

const addressdetaillist = [{
        prop: "OrderId",
        label: "收件人姓名",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,
    },
    {
        prop: "CreateTime",
        label: "收件人电话",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    },
    {
        prop: "Type",
        label: "收件人地址",
        width: "100",
        align: 'left',
        headerAlign: 'left',
        selection: false,
        index: false,
        expand: false,

    }
]

export {
    grouplist,
    subaccountlist,
    orderList,
    renewList,
    lineRenewList,
    filecloumns,
    filestoragelist,
    channelmainaccount,
    channelsubaccount,
    channelResrouce,
    channelMainResrouce,
    moneydetaillist,
    invoicelist,
    invoicedetaillist,
    invoicedetaillist2,
    addressdetaillist,
    appList,
}
